import { useContext } from 'react';

import { TenantContext } from '@app/contexts/TenantContext';

export function useTenant() {
  return useContext(TenantContext);
}
